import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    SPIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={SPIconImg} preview={false}/>
